import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useFlipOrderMutation } from '../../../features/Dispatch/TripDispatchSlice';
import errorHandler from '../../hooks/ErrorHanlder';
import { toast } from 'react-toastify';


const FlipOrdersDialog = ({ orderData, orderClassification, getTripOrdersClassification, selectedTrip, divisionIdRef }) => {
  const [show, setShow] = useState(false);
  const [flipOdderByStatus] = useFlipOrderMutation()
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const statusMap = {
    'O': 'Open',
    'L': 'Loading',
    'OUT': 'Outbound',
    'IN': 'Inbound',
    'C': 'Completed',
  }
  const from = orderClassification?.split(" ")[0]
  const to = orderClassification === 'Outbound Orders' ? 'Inbound' : 'Outbound'

  const onSubmit = async () => {
    try {
      await flipOdderByStatus({
        orderID: orderData?.id,
        manualOrderClassification: to
      }).unwrap()
      toast.success("Order flipped successfully!", { position: 'top-center' });
      await getTripOrdersClassification({ tripStatus: statusMap[selectedTrip?.tripStatusCode], tripId: selectedTrip?.tripID, divisionId: divisionIdRef.current })
      handleClose();
    } catch (error) {
      errorHandler(error)
    }
  }
  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Flip
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Flip Order Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {`Are you sure you want to flip this order status ${from} to ${to}?`}
        </Modal.Body>
        <div className='d-flex gap-3 p-3 justify-content-end'>
          <Button style={{ width: "120px" }} variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button style={{ width: "120px" }} variant="primary" onClick={onSubmit}>
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default FlipOrdersDialog;